import dayjs from "dayjs";
import getB from "../../utils/bridges/EkaBridge";
import { getIdb } from "../../utils/bridges/methods";

export async function generateAppointmentToken({
  clinicId,
  doctorId,
  date,
}: {
  clinicId: string;
  doctorId: string;
  date: Date;
}) {
  try {
    const dayStart = dayjs(date).startOf("day").unix() * 1000;
    const dayEnd = dayjs(date).endOf("day").unix() * 1000;
    const apts = await getIdb()
      .appointments.where("[clinic_id+full_date]")
      .between([clinicId, dayStart], [clinicId, dayEnd])
      .filter(
        (a) =>
          a.doctor_oid === doctorId &&
          typeof a.token === "number" &&
          a.full_date >= dayStart &&
          a.full_date <= dayEnd &&
          a.clinic_id === clinicId
      )
      .toArray();

    return apts.length + 1;
  } catch (e) {
    console.error("ERROR =====> generateAppointmentToken", e);
  }
}
